import { Payment, DescriptionCode, ProductName } from '@lendica/utils';
import { useEffect, useState } from 'react';
import { FilterItem } from '../components/AllFilters';
import { FilterType } from '../components/FilterBar';

// TODO: in this hook should be done all data transformation such as, filtering, sorting etc
// *key and *type properties in FilterItem interface should/can be the properties which can help do the proper filtering, sorting etc.
export const useUpcomingPayments = ({
    payLater,
    drawDown,
    fundNow,
    payments,
}: {
    payLater: boolean;
    drawDown: boolean;
    fundNow: boolean;
    payments: Payment[];
}) => {
    const [filtersList, setFiltersList] = useState<FilterItem[]>([]);

    const getDealIds = () => {
        let deals: { [key: string]: any } = {};
        payments.forEach(payment => {
            let dealId = payment.deal.substring(0, 8);
            if (deals[dealId] == undefined) {
                deals[dealId] = {
                    label: dealId,
                    value: payment.deal,
                };
            }
        });
        return Object.values(deals);
    };

    useEffect(() => {
        let productFilter: FilterItem = {
            key: 'product',
            type: FilterType.SELECT_FILTER,
            label: 'Product',
            defaultValue: [],
            sectionLabel: 'Filter by product',
            options: [
                {
                    label: 'PayLater',
                    value: ProductName.PayLater,
                },
                {
                    label: 'FundNow',
                    value: ProductName.FundNow,
                },
                {
                    label: 'DrawDown',
                    value: ProductName.DrawDown,
                },
            ],
        };

        let dealIdFilter: FilterItem = {
            key: 'dealId',
            type: FilterType.SELECT_FILTER,
            label: 'Deal ID',
            defaultValue: [],
            sectionLabel: 'Filter by deal ID',
            options: getDealIds(),
        };

        setFiltersList([dealIdFilter, productFilter]);
    }, [payments]);

    return { filtersList };
};
